function initEpFacetsToolbar() {
  const toolbars = document.querySelectorAll('.ep-facets-toolbar');
  if (!toolbars.length) return;

  toolbars.forEach((toolbar) => {
    toolbar.querySelectorAll('.ep-facet-toolbar-item').forEach((item) => {
      if (item.dataset.epBound === 'true') return;
      item.dataset.epBound = 'true';

      item.addEventListener('toggle', () => {
        if (!item.open) return;

        toolbar.querySelectorAll('.ep-facet-toolbar-item').forEach((other) => {
          if (other !== item) {
            other.open = false;
          }
        });
      });
    });
  });
}

function closeEpFacetsToolbarOnOutsideClick(event) {
  document.querySelectorAll('.ep-facets-toolbar').forEach((toolbar) => {
    if (toolbar.contains(event.target)) return;

    toolbar.querySelectorAll('.ep-facet-toolbar-item[open]').forEach((item) => {
      item.open = false;
    });
  });
}

if (!window.__epFacetsToolbarOutsideBound) {
  document.addEventListener('click', closeEpFacetsToolbarOnOutsideClick);
  window.__epFacetsToolbarOutsideBound = true;
}

document.addEventListener('DOMContentLoaded', initEpFacetsToolbar);

if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.facetUpdate, () => {
    window.setTimeout(initEpFacetsToolbar, 0);
  });
}
